import { UserButton } from '@clerk/clerk-react';
import { Badge, IconButton } from '@/components/ui';
import { Icon } from '@/lib/icons';
import { IqName } from '@/components/IqName';
import { useSearch } from './search';

export function Topbar({ title, onMenu, onAssistant }: { title: string; onMenu?: () => void; onAssistant?: () => void }) {
  const { query, setQuery } = useSearch();
  return (
    <header className="dash-top">
      <button className="dash-top__menu" type="button" onClick={onMenu} aria-label="Open menu">
        <Icon name="menu" size={22} />
      </button>
      <div className="dash-top__title">
        <h1><IqName text={title} /></h1>
        <Badge variant="success" dot>
          All systems live
        </Badge>
      </div>
      <div className="dash-top__tools">
        <div className="dash-search">
          <Icon name="search" size={16} />
          <input
            placeholder="Search leads…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          {query && (
            <button className="dash-search__clear" aria-label="Clear search" onClick={() => setQuery('')}>
              <Icon name="x" size={14} />
            </button>
          )}
        </div>
        {onAssistant && (
          <button type="button" className="dash-ask" onClick={onAssistant}>
            <Icon name="sparkles" size={16} /><span>Ask tritonIQ</span>
          </button>
        )}
        <IconButton label="Notifications" variant="outline">
          <Icon name="bell" size={18} />
        </IconButton>
        <UserButton
          appearance={{ elements: { avatarBox: { width: 36, height: 36 } } }}
        />
      </div>
    </header>
  );
}
